<template>
    <div>
        <div v-if="tableItems.length > 0">
            <b-table class="table b-table table-striped table-hover table-bordered" :items="tableItems" :fields="tableFields">
                <template #cell(xMunIni)="data">
                    <div>{{ data.item.xMunIni }} - {{ data.item.UFIni }}</div>
                </template>

                <template #cell(xMunFim)="data">
                <div>{{ data.item.xMunFim }} - {{ data.item.UFFim }}</div>
            </template>
            <template #head(selecionado)>
                <div class="text-center pl-2">
                    <b-form-checkbox :checked="false" v-model="checkboxSelecionaTodos" @change="selecionaTodos" />
                </div>
            </template>
            <template #cell(selecionado)="data">
                <div class="text-center pl-2">
                    <b-form-checkbox :checked="data.item.selecionado" @change="selecionaRegistro(data.index)" />
                </div>
            </template>
            <template #cell(dest.xnome)="data">
                <div>
                    {{ data.item.dest && data.item.dest.xnome ? data.item.dest.xnome : '-'  }}
                </div>
            </template>
            <template #cell(rem.xnome)="data">
                <div>
                    {{ data.item.rem && data.item.rem.xnome ? data.item.rem.xnome : '-'  }}
                </div>
            </template>
            <template #cell(situacao)="data">
                <div>
                    <b-badge 
                        v-b-tooltip.hover 
                        :title="data.item.situacao == 'Reprovado' ? data.item.xmotivo : data.item.situacao" 
                        :variant="data.item.classe_situacao"
                    >{{ data.item.situacao }}</b-badge>
                </div>
            </template>
            <template #cell(acoes)="data">
                <div class="coluna-acoes4">
                    <b-button :to="`${$urlBase}/conhecimentos/visualizar/${data.item.id}`" v-b-tooltip.hover title="Visualizar" variant="info" size="xs" class="mr-1">
                        <i class="glyphicon glyphicon-search" />
                    </b-button>
                    <b-button @click="abreEditarCte(data.item.id, data.item.situacao)" v-b-tooltip.hover variant="warning" title="Editar" size="xs" class="mr-1">
                        <i class="glyphicon glyphicon-edit" />
                    </b-button>
                    <b-button :disabled="permiteEdicao(data.item.situacao) ? false : true" v-b-tooltip.hover title="Deletar" @click.prevent="deleta($route, data.item)" :variant="permiteEdicao(data.item.situacao) ? 'danger' : 'light'" size="xs" class="botao-excluir">
                        <i class="glyphicon glyphicon-remove" />
                    </b-button>
                    <b-dropdown id="botao-mais-acoes" v-b-tooltip.hover title="Mais ações" class="ml-1" size="xs" variant="success" right boundary="window">
                        <b-dropdown-item @click="transmitir(data.item.id)" class="mais_acoes" v-if="data.item.situacao == 'Em aberto' || data.item.situacao == 'Reprovado'">
                            <i class="text-success fa icon-sync mr-2" />Emitir CT-e
                        </b-dropdown-item>
                        <b-dropdown-item @click="imprimirDacte(data.item.id)" class="mais_acoes">
                            <i class="text-primary fa fa-print mr-2" /> Imprimir DACTE
                        </b-dropdown-item>
                        <b-dropdown-item @click="abreModalCompartilhaWhatsapp(data.item.id, data.item.receb.fone)" class="mais_acoes">
                            <i class="text-success fa icon-whatsapp mr-2" /> Compartilhar
                        </b-dropdown-item>
                        <b-dropdown-item v-if="data.item.situacao == 'Autorizado' || data.item.situacao == 'Cancelado'" @click="baixarXml(data.item.id)" class="mais_acoes">
                            <i class="text-muted icon-font icon-file-xml mr-2" /> Baixar XML
                        </b-dropdown-item>
                        <b-dropdown-item @click="abreModalEnviaEmail(data.item.id, data.item.ide_nct, data.item.receb.email)" class="mais_acoes">
                            <i class="text-warning fa icon-envelope mr-2" /> Enviar por email
                        </b-dropdown-item>
                        <b-dropdown-item @click="abreModalCancelarConhecimento(data.item.id)" class="mais_acoes" v-if="data.item.situacao == 'Autorizado'">
                            <i class="text-danger fa fa-ban mr-2" /> Cancelar CT-e
                        </b-dropdown-item>
                        <b-dropdown-item @click="abreModalPagamento(data.item.id, data.item.ide_nct, data.item.dest.xnome, data.item.vtprest)" class="mais_acoes" v-if="data.item.situacao == 'Autorizado' && !data.item.has_movimentacao && $urlBase == '/cte' && permitirGerarFinanceiro">
                            <i class="text-success fa icon-moneybag mr-2" /> Gerar financeiro
                        </b-dropdown-item>
                        <b-dropdown-item :href="`/movimentacoes_financeiras?nome=CT-e de nº ${data.item.ide_nct}&data_inicio=&data_fim=`" class="mais_acoes" v-if="data.item.situacao == 'Autorizado' && data.item.has_movimentacao && $urlBase == '/cte' && permitirGerarFinanceiro">
                            <i class="text-success fa icon-moneybag mr-2" /> Ver no financeiro
                        </b-dropdown-item>
                    </b-dropdown>
                </div>
            </template>
            </b-table>
            <b-row>
                <b-col sm="6" class="text-center text-md-left">
                    Mostrando {{ paginacao.from }} a {{ paginacao.to }} de um total de
                    {{ paginacao.total }}
                </b-col>
                <b-col v-if="paginacao.lastPage > 1" sm="6" class="d-flex justify-content-center justify-content-md-end">
                    <b-pagination
                        v-model="paginacao.currentPage"
                        :total-rows="paginacao.total"
                        :per-page="paginacao.perPage"
                        align="right"
                        @change="paginando($event)"
                    ></b-pagination>
                </b-col>
            </b-row>
        </div>
        <ListaVazia 
            v-if="tableItems.length == 0 && !dSituacaoBuscaAvancada"
            :icone="listaVazia.icone"
            :titulo="listaVazia.titulo"
            :descricao="listaVazia.descricao"
            :botoes="listaVazia.botoes"
            :tituloLista="listaVazia.tituloLista"
            :lista="listaVazia.lista"
            :possuiVideoTutorial="true"
        />
 
        <b-row v-if="tableItems.length == 0 && dSituacaoBuscaAvancada" class="no-result">
            <b-col sm="12">
                <i class="glyphicon glyphicon-warning-sign" />
            </b-col>
            <b-col sm="12">
                <h3>Nenhum CT-e foi encontrado!</h3>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { mapWritableState, mapState, mapActions } from 'pinia'
import { useListaStore } from '../../stores/Lista'
import ListaVazia from '@/shared/components/crud/lista/ListaVazia'

export default {
    components: {
        ListaVazia
    },
    props: {
        permitirGerarFinanceiro: {
            default: true
        }
    },
    computed: {
        ...mapState(useListaStore, [
            'tableFields', 
            'tableItems', 
            'listaVazia',
            'dSituacaoBuscaAvancada'
            
        ]),
        ...mapWritableState(useListaStore, [
            'paginacao',
            'checkboxSelecionaTodos'
        ])
    },
    methods: {
        ...mapActions(useListaStore, [
            'carregaDados', 
            'paginando',
            'deleta', 
            'transmitir', 
            'baixarXml',
            'abreModalCompartilhaWhatsapp',
            'abreModalEnviaEmail',
            'selecionaTodos',
            'selecionaRegistro',
            'permiteEdicao',
            'abreModalCancelarConhecimento',
            'abreModalPagamento',
            'imprimirDacte',
            'abreEditarCte'
        ])
    }
}
</script>

<style scoped>
#botao-mais-acoes ul li i,
.dropdown-menu.dropdown-menu-right li a i {
    height: 16px;
    width: 17px;
    text-align: center;
}
</style>

